import React, {useContext, useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';
import {useKeycloak} from '@react-keycloak/web';

import {Button, message, Modal} from 'antd';
import {DeleteOutlined, EditOutlined} from '@ant-design/icons';
import AppCard from '@crema/core/AppCard';

import {MediaContext} from '../../MediaContext';
import {deleteMedia} from 'services/MediaService';
import {handleError} from 'utils/MessageUtils';
import {MediaType} from 'shared/constants/AppConst';

const ListItem = (props) => {
  const {item} = props;

  const confirm = Modal.confirm;

  const {keycloak} = useKeycloak();
  const intl = useIntl();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const mediaContext = useContext(MediaContext);
  const {readOnly, setSelectedMediaId, setReloading, setViewing, setEditing} =
    mediaContext;

  const [thumbnailUrl, setThumbnailUrl] = useState('');

  useEffect(() => {
    if (item.type === MediaType.IMAGE) {
      setThumbnailUrl(item.url);
    } else if (item.type === MediaType.AUDIO) {
      setThumbnailUrl('/assets/images/audio.jpg');
    } else if (item.type === MediaType.VIDEO) {
      setThumbnailUrl('/assets/images/video.jpg');
    } else if (item.type === MediaType.DOCUMENT) {
      setThumbnailUrl('/assets/images/document.png');
    } else if (item.type === MediaType.DICOM) {
      setThumbnailUrl('/assets/images/medical.png');
    }
  }, [item]);

  const showDetail = (id) => {
    setSelectedMediaId(id);
    setViewing(true);
  };

  const showConfirm = (id) => {
    confirm({
      title: intl.messages['common.confirmDelete'],
      content: '',
      onOk() {
        deleteMedia(headers, id)
          .then(() => {
            message.success(intl.messages['common.deleted']);
            setReloading(true);
          })
          .catch((error) => handleError(message, error));
      },
    });
  };

  const onEdit = (id) => {
    setSelectedMediaId(id);
    setEditing(true);
  };

  const onDelete = (id) => {
    showConfirm(id);
  };

  return (
    <AppCard className='product-list-card item-hover'>
      <div className='product-list-card-content'>
        <div className='product-list-slider'>
          <div className='product-list-slider-thumb' key={item.id}>
            <img
              src={thumbnailUrl}
              alt='media'
              onClick={() => {
                if (
                  item.type === MediaType.DOCUMENT ||
                  item.type === MediaType.DICOM
                ) {
                  window.open(item.url, '_blank');
                } else {
                  showDetail(item.id);
                }
              }}
            />
          </div>
        </div>

        <div className='product-list-slider-content'>
          <div className='product-list-slider-content-header'>
            <h3 className='text-truncate'>
              <a
                onClick={() => {
                  if (
                    item.type === MediaType.DOCUMENT ||
                    item.type === MediaType.DICOM
                  ) {
                    window.open(item.url, '_blank');
                  } else {
                    showDetail(item.id);
                  }
                }}>
                {item.title}
              </a>
            </h3>

            {!readOnly && (
              <span
                className='product-list-favor-checked'
                style={{paddingRight: '5px', textAlign: 'right'}}>
                <Button
                  icon={<EditOutlined />}
                  onClick={() => onEdit(item.id)}
                  style={{border: 0, backgroundColor: 'transparent'}}
                />
                <Button
                  icon={<DeleteOutlined />}
                  onClick={() => onDelete(item.id)}
                  style={{border: 0, backgroundColor: 'transparent'}}
                />
              </span>
            )}
          </div>

          <p className='product-list-card-content-para'>{item.note}</p>

          <div className='product-list-action'>
            <div className='product-list-action-item add-to-com'></div>
            <div className='product-list-action-item'></div>
          </div>
        </div>
      </div>
    </AppCard>
  );
};

export default ListItem;

ListItem.propTypes = {
  item: PropTypes.object.isRequired,
};
